import React from "react";
import "../styles/FaleConosco.css";

import { GrContact } from "react-icons/gr";
import { GiReceiveMoney, GiTakeMyMoney } from "react-icons/gi";
import { FaWhatsapp, FaInstagram, FaGoogle } from "react-icons/fa";
import { MdEmail } from "react-icons/md";

function FaleConosco() {
  return (
    <div className="contato-page">
      <h2>Entre em contato com a gente!</h2>
      <div className="container-ContatcPage">
        <div className="blocoContact">
          <GrContact className="iconContactBloco" />
          <h3>Entre em contato com a gente para tirar dúvidas!</h3>
          <div className="iconsContato">
            <a href="https://wa.me/5532999956939?text=Ol%C3%A1%2C%20venho%20diretamente%20do%20link%20de%20d%C3%BAvidas%20do%20site." target="_blank" rel="noreferrer">
              <FaWhatsapp />
            </a>
            <a href="mailto:contato@sennaviannini.com.br" target="_blank" rel="noreferrer">
              <MdEmail />
            </a>
          </div>
          <h5>Clique nos icones para entrar em contato</h5>
        </div>
        <div className="blocoContact">
          <GiReceiveMoney className="iconContactBloco" />
          <h3>Deseja disponibilizar seu imóvel para aluguel?</h3>
          <div className="iconsContato">
            <a href="https://wa.me/5532999956939?text=Ol%C3%A1%2C%20gostaria%20de%20alugar%20o%20meu%20im%C3%B3vel!" target="_blank" rel="noreferrer">
              <FaWhatsapp />
            </a>
            
          </div>
          <h5>Clique nos icones para entrar em contato</h5>
        </div>
        <div className="blocoContact">
          <GiTakeMyMoney className="iconContactBloco" />
          <h3>Deseja disponibilizar seu imóvel para venda?</h3>
          <div className="iconsContato">
            <a href="https://wa.me/5532999003833?text=Ol%C3%A1%2C%20gostaria%20de%20vender%20meu%20im%C3%B3vel!" target="_blank" rel="noreferrer">
              <FaWhatsapp />
            </a>
            
          </div>
          <h5>Clique nos icones para entrar em contato</h5>
        </div>
      </div>
      <div className="containerRedes">
        <div className="iconesRedes">
          <a href="https://www.instagram.com/sennaviannini/">
            <FaInstagram className="iconRede" />
          </a>
          <a href="https://www.google.com/search?q=senna+viannini&sourceid=chrome&ie=UTF-8">
            <FaGoogle className="iconRede" />
          </a>
          
        </div>
      </div>
    </div>
  );
}

export default FaleConosco;
